export const addItemToHistory = (historyItems, historyItemToAdd) => {
    return [...historyItems, { ...historyItemToAdd }];
};